import { render } from "./ZapiPaymentSelector.vue?vue&type=template&id=4a7b1209&scoped=true"
import script from "./ZapiPaymentSelector.vue?vue&type=script&lang=js"
export * from "./ZapiPaymentSelector.vue?vue&type=script&lang=js"

import "./ZapiPaymentSelector.vue?vue&type=style&index=0&id=4a7b1209&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7b1209"]])

export default __exports__